export default "__VITE_ASSET__DVYc0P38__"